import { baseApi } from '@shared/api'

interface SetByMeRespone {
  id: number;
  fullName: string;
  pin: string;
  phone: string;
  expiryDate: string;
}

export const trustedPersonApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchTrustedPersonByPin: builder.query<any, { pin: string }>({
        query: ({ pin }) => ({
          url: '/ib/core/trusted-person/by-pin',
          data: { pin },
          method: 'POST',
        }),
      }),
      fetchTrustedPersonListAll: builder.query({
        query: () => ({
          url: '/ib/core/trusted-person/get-all',
          method: 'POST',
          skipGlobalError: true,
        }),
        providesTags: (result, err) => {
          return [{ type: 'TrustedPersonList' }];
        }
      }),
      deleteTrustedPerson: builder.mutation({
        query: (data) => ({
          url:  '/ib/core/trusted-person/delete',
          method: 'POST',
          data
        }),
        invalidatesTags: ['TrustedPersonList'],
      }),
      setByMe: builder.query<SetByMeRespone, void>({
        query: () => ({
          url:  '/ib/core/trusted-person/customers-by-pin',
          method: 'POST',
          skipGlobalError: true,
        })
      })
    }
  },
})

export const {
  useFetchTrustedPersonByPinQuery,
  useLazyFetchTrustedPersonByPinQuery,
  useFetchTrustedPersonListAllQuery,
  useLazyFetchTrustedPersonListAllQuery,
  useDeleteTrustedPersonMutation,
  useLazySetByMeQuery,
  useSetByMeQuery,
} = trustedPersonApi
